/**
 * Vetra transceiver
 * - communication with trams
 * - tram sends information about itself and its intentions (direction)
 * - used in Olsztyn
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

import Konva from 'konva'
import i18n from '../../../../i18n'

export default class Vetra extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'vetra',
        x: 0,
        y: 0,
        width: 170,
        height: 60,
        strokeWidth: 1,
        fill: Color.onlineWhite,
        opacity: 1
      }),

      new Ren.Line({
        points: [0, 20, 170, 20],
        strokeWidth: 1,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [95, 0, 95, 60],
        strokeWidth: 1,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [20, 0, 20, 60],
        strokeWidth: 1,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [0, 40, 170, 40],
        strokeWidth: 1,
        opacity: 0.8
      }),

      new Konva.Text({
        x: 25,
        y: 5,
        text: i18n.t('variable.vehicleId'),
        fontSize: 12,
        fill: 'black'
      }),

      new Konva.Text({
        x: 100,
        y: 5,
        text: i18n.t('variable.routeCode'),
        fontSize: 12,
        fill: 'black'
      }),

      new Konva.Text({
        name: 'vehicleIdPlaceholder',
        x: 25,
        y: 25,
        text: '',
        fontSize: 12,
        fill: 'black'
      }),

      new Konva.Text({
        name: 'routeCodePlaceholder',
        x: 100,
        y: 25,
        text: '',
        fontSize: 12,
        fill: 'black'
      }),

      new Konva.RegularPolygon({
        name: 'straight',
        x: 10,
        y: 35,
        sides: 3,
        radius: 7,
        scaleY: 1,
        stroke: 'black',
        fill: 'black',
        visible: false
      }),

      new Konva.RegularPolygon({
        name: 'right',
        x: 8,
        y: 30,
        sides: 3,
        radius: 7,
        scaleY: 1,
        stroke: 'black',
        fill: 'black',
        rotation: '90',
        visible: false
      }),

      new Konva.RegularPolygon({
        name: 'left',
        x: 10,
        y: 30,
        sides: 3,
        radius: 7,
        scaleY: 1,
        stroke: 'black',
        fill: 'black',
        rotation: '270',
        visible: false
      }),

      new Konva.Text({
        name: 'directionPlaceholder',
        x: 5,
        y: 25,
        text: '',
        fontSize: 12,
        fill: 'black'
      })
    )
  }

  setVetra (status) {
    return new Promise((resolve, reject) => {
      const vehicles = status.vehicleTransit
      // console.log("VEHICLES")
      // console.log(vehicles)
      // first element is label
      const vehicleId = vehicles[2][1]
      const direction = vehicles[0][1]
      const routeCode = vehicles[1][1] === null ? '' : `${vehicles[1][1]}`

      if (vehicleId && direction) {
        this.modifyShape('vehicleIdPlaceholder', 'text', vehicleId)
        this.showDirection(direction)
        this.modifyShape('routeCodePlaceholder', 'text', routeCode)
        resolve('Done')
      } else {
        // reject('Missing data')
      }
    })
  }

  showDirection (direction) {
    this.modifyShape('straight', 'visible', direction === 'straight')
    this.modifyShape('left', 'visible', direction === 'left')
    this.modifyShape('right', 'visible', direction === 'right')
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    // online
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)
    // console.log("STATUS FROM SHV")
    // console.log(status)
    if (status.vehicleTransit) {
      this.modifyShape('vetra', 'fill', Color.onlineWhite)
      this.setVetra(status).then(value => {
        setTimeout(() => {
          // console.log("REMOVE VETRA VALUE")
          // console.log(status.vehicleTransit[2][1])
          this.modifyShape('vehicleIdPlaceholder', 'text', '')
          this.modifyShape('right', 'visible', false)
          this.modifyShape('left', 'visible', false)
          this.modifyShape('straight', 'visible', false)
          this.modifyShape('routeCodePlaceholder', 'text', '')
          const layer = this.shapes.find(s => s.attrs.name === 'vehicleIdPlaceholder').getLayer()
          if (layer) {
            layer.batchDraw()
          }
        }, 10000)
      })
      // setTimeout(this.modifyShape('vehicleIdPlaceholder', 'text', 'WHO KNOWS'), 20000)
    }

    if (this.online) {
      this.modifyShape('vetra', 'fill', Color.onlineWhite)
    }
  }
}
